// This file handles API calls related to authentication
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Authentication service class
class AuthService {
  // Login method
  async login(email: string, password: string) {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();
    if (data.accessToken) {
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    return data;
  }

  // Logout method
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
  // Register method
  register(first_name: string, last_name: string, email: string, password: string, phone: string) {
    return axios.post(`${BASE_URL}/auth/register`, {
      first_name,
      last_name,
      email,
      password,
      phone
    });
  }
  // Get current user
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }
  
  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('token');
  }
  
  // Validate token (check if it's still valid)
  async validateToken() {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
      try {
      // Call an endpoint that requires authentication to check token validity
      await axios.get(`${BASE_URL}/auth/validate`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return true;
    } catch (error) {
      // If we get a 401, the token is invalid
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        this.logout();
        return false;
      }
      // For other errors (like network issues), assume token is still valid
      return true;
    }
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;

